export default __webpack_public_path__ + "static/media/11.947a77e1.jpg";